import { DEFAULT_DATABASE_PLAN } from '@cli-constants/commands.js'

export function neonAddArgs(options: { plan?: string }, output: 'json' | 'interactive'): string[] {
  const args = ['integration', 'add', 'neon']
  if (output === 'json') args.push('--format', 'json')
  args.push('--plan', options.plan ?? DEFAULT_DATABASE_PLAN)
  return args
}
